package ai.wagemix.net.client

import ai.wagemix.net.models.WMPasswordResetRequest
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.FSRequestBuilder
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.replacePathParams

/** `POST /api/v1/password-resets`: emails a reset link if the address has an account; always answers 202. */
class WMRequestPasswordResetRequestBuilder:
    FSRequestBuilder<WMRequestPasswordResetRequestBuilder, WMPasswordResetRequest>() {

    override fun build(): FSRequest<WMPasswordResetRequest> {
        method(FSRequest.Method.Post)
        replacePathParams("api", "v1", "password-resets")
        acceptJson()
        contentTypeJson()
        return super.build()
    }

    override fun self(): WMRequestPasswordResetRequestBuilder = this
}
